const StepperButton = (props: any) => {
    return (
      <button className={props.styleClass} onClick={props.onClick}>
        <span>{props.children}</span>
      </button>
    );
}

export default StepperButton;